import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      // Sans ceci, Lenis intercepte la molette et BLOQUE le défilement des zones
      // internes : fenêtres modales, panneaux plein écran, zones du dossier, etc.
      // Tout conteneur marqué .aca-modal / .aca-section-scroll / .aca-dragscroll
      // (ou data-lenis-prevent) garde son défilement natif.
      prevent: (node) => !!(node && node.closest && node.closest(".aca-modal, .aca-section-scroll, .aca-dragscroll, [data-lenis-prevent]")),
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return children;
}
